// import * as deviceService from 'services/device-service';
// import * as tenantService from 'services/tenant-service';
import { AuditLogType } from 'types/audit-log-type';
import { dateToTicks } from 'helpers/date-helper';
import { Guid } from 'types/guid';
import { MiddlewareAPI } from 'redux';
import { WriteAuditLogAction } from 'components/audit-logs/actions';
import { usernameSelector } from 'pages/user-profile/selectors';
import { APPLICATION_VERSION } from 'config';

export async function writeAuditLog(store: MiddlewareAPI, auditLogType: AuditLogType, action: string, operation: string,
                                    message: string, online?: boolean) {
  const state = store.getState();
  store.dispatch(new WriteAuditLogAction({
    id: Guid.newGuid(),
    auditLogType,
    tenantId: '', // (await tenantService.getTenantId()).toString(),
    deviceId: '', // (await deviceService.getDeviceId()).toString(),
    timestamp: dateToTicks(new Date()),
    username: usernameSelector(state),
    action,
    operation,
    message,
    online,
    uiVersion: APPLICATION_VERSION
  }));
}


// WEBPACK FOOTER //
// ./src/helpers/audit-log-helper.ts